<script setup lang="ts">
import Galleria from 'primevue/galleria'

// Number of thumbnails shown alongside the active image.
const THUMBNAIL_COUNT = 3

interface Props {
  images: string[]
  visible: boolean
}

const emit = defineEmits<{ 'update:visible': [value: boolean] }>()
defineProps<Props>()
</script>

<template>
  <Galleria
    :value="images"
    :visible="visible"
    :num-visible="THUMBNAIL_COUNT"
    :circular="true"
    :full-screen="true"
    :show-item-navigators="true"
    :show-thumbnails="true"
    @update:visible="emit('update:visible', $event)"
  >
    <template #item="{ item }">
      <div class="app-galleria__item-wrap">
        <img :src="item" class="app-galleria__img" alt="Property" />
      </div>
    </template>
    <template #thumbnail="{ item }">
      <img :src="item" class="app-galleria__thumb" alt="" />
    </template>
  </Galleria>
</template>

<style>
/* Unscoped — PrimeVue Galleria's full-screen mask teleports outside the
   component tree, so a scoped `data-v-*` attribute can't reach it. */
/* ── Backdrop — dark blur so images stand out ── */
.p-galleria-mask {
  background: rgba(10, 10, 18, 0.82) !important;
  backdrop-filter: blur(12px) !important;
}

/* ── Gallery panel — fixed size, never grows with image ── */
.p-galleria {
  width: min(90vw, 1100px) !important;
  max-width: min(90vw, 1100px) !important;
}

.p-galleria-item-wrapper {
  width: 100% !important;
}

/* ── Item slot — fixed height, content centered ── */
.p-galleria-item {
  width: 100% !important;
  height: 70vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.app-galleria__item-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-galleria__img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

/* ── Thumbnails ── */
.app-galleria__thumb {
  width: 80px;
  height: 56px;
  object-fit: cover;
  display: block;
  border-radius: 4px;
}
</style>
